/// <reference path="/js/libs/hmac-md5.js" />
/// <reference path="/js/libs/wtcp.util.js" />
/// <reference path="/js/libs/wtcp.locator.js" />

const wtcpUtil = require('./wtcp.util.js');

global.WtcpJs = global.WtcpJs || {};

(function (wtcp) {
    "use strict";

    var util = require('./wtcp.util.js');
    var resp = require('./wtcp-types/ErrorResponse.js');
    var ai = require('./wtcp-types/requests/AnchorInfo.js');
    var pmReq = require('./wtcp-types/requests/PrivateTextMessageRequest.js');
    var audio = require('./wtcp.wtcpaudio.js');
    var locService = require('./wtcp.locator.js');
    var uaParser = require('ua-parser-js');

    const WTCPJS_CLIENT_OFFSET = 0x1B58;

    var eventList = {
        PROXY_UPDATED: "pu1",
        CHANNEL_PROPS_RECEIVED: "cp1",
        CHANNEL_ACTIVITY: "ca1",
        ENDPOINT_PROPS_RECEIVED: "ep1",
        PTT_OFF: "po1",
        DTMF_RECEIEVED: "dr1",
        CALL_PTT_ON_RECEIVED: "cpor1",
        CALL_PTT_OFF_RECEIVED: "cpor2",
        TXT_MSG_RECEIVED: "tm1",
        OPEN_SESSION_RECEIVED: "sr1",
        SESSION_CLOSED_RECEIVED: "scr1",
        PING_PONG_RESPONSE: "ppr",
        SOCKET_CLOSED: "sc1",
        SIGNAL_RECEIVED: "sr2",
        PHONE_LINE_STATUS_CHANGED: "plsc",
        CALL_PROGRESS_RECEIVED: "cpr",
        CALL_HANGUP_RECEIVED: "chr",
        CALL_OFFER_RECEIVED: "cor",
        CONNECTION_INFO_UPDATED: "lu",
        PRIV_MEDIA_MSG_RECEIVED: "pmmr"
    };

    var proxyInstanceCnt = 0;
    var proxyGlobals = {};
    var transCounter = 0; // transaction counter 1..36767

    var wtcpJsClientErrors = {
        "PTT_NOT_READY": (() => {
            let err = new WtcpJs.ErrorResponse();
            err.errorCode = WTCPJS_CLIENT_OFFSET | 1;
            err.errorMessage = "You cannot PTT again until the WtpcjJs client handles the PTTUp response";

            return err;
        })()
    };

    var registerInstance = function registerInstance() {
        var id = "proxy_instance_" + proxyInstanceCnt++;
        proxyGlobals[id] = {};

        return id;
    };

    var pushCallbacks = function pushCallbacks(map, res, rej) {
        // use transaction counter as a key for the map 
        // use one counter for all maps (don't need to have individual counter for every map) 
        // some leftover key will be gone after one cycle loop due to a missing response
        transCounter = (transCounter + 1) % 36768; 
        // valid transaction range is [1..36767] 
        if(transCounter == 0) transCounter = 1; 
        map.set(transCounter,{ resolve: res, reject: rej })
        return transCounter; 
    };

    var getCallback = function getCallback(map, key) {
        var cb;
        if (!map.has(key)) {
            if (map.size > 0)  { // pick the last one -- this is a bad code smell (bug 46475) it appears that unit test will make this bad situation.
                wtcpUtil.wtcpInfo(`ALERT: number of keys : ${map.size} map = ${map.toString()}`);
                for(let k of map.keys())
                    key = k;
                wtcpUtil.wtcpInfo("ALERT: Fetch the last key instead for given key:", key)
            }
        }
        // if key is still missing, return undefined 
        cb = map.get(key);
        map.delete(key)
        return cb; 
    };

    var ua = null;
    if(window && window.navigator) {
        ua = uaParser(navigator.userAgent);
    }

    wtcp.Client = function (clientOptions, clientWorker) {

        if (!(this instanceof wtcp.Client)) return new wtcp.Client(clientOptions);

        /* --- Private variables --- */

        var local = {};
        var defaults = {
            profileId: "",
            pingInterval: 30,
            initialVolume: 100,
            audioPlayerActive: true,
            loggingLevel: 0,
            exportOutboundAudio: false,
            processorNodeBufferSize: 8192,
            outboundAudioFile: 'audio.wav',
            deviceId: "HTML5 capable browser",
            applicationName: 'MOT-WTCPJS-1.1',
            licenseUUID: "{436C743D-896D-456e-A61B-6F564F3D2C78}" // default to WAVE_LICENSE_WTC_SDK
        };

        var socketActive = false;
        var locator;
        var serverUrlPattern = /^ws{1,2}:\/\//;
        var httpsPattern = /^https:\/\//;
        var settings = {};
        var pttDownPending = false;
        var pttUpPending = false;
        var pttUpSuccess = null;
        var pttUpFailure = null;
        var pttOn = false;
        var requestTimeoutId;

        var callbacks = {
            socketConnectedCallbacks: new Map(),
            sendCredentialsCallbacks: new Map(),
            getChannelPropsCallbacks: new Map(),
            setChannelPropsCallbacks: new Map(),
            getEndpointLookupCallbacks: new Map(),
            getEndpointPropsCallbacks: new Map(),
            setEndpointPropsCallbacks: new Map(),
            setActiveChannelsCallbacks: new Map(),
            setActivePhoneLinesCallbacks: new Map(),
            pttDownCallbacks: new Map(),
            muteChannelCallbacks: new Map(),
            dtmfSendCallbacks: new Map(),
            callPTTOnCallbacks: new Map(),
            callPTTOffCallbacks: new Map(),
            addressBookCallbacks: new Map(),
            textMessageCallbacks: new Map(),
            endpointFilteringCallbacks: new Map(),
            endpointPropFilteringCallbacks: new Map(),
            openSessionCallbacks: new Map(),
            closeSessionCallbacks: new Map(),
            channelActivityCallbacks: new Map(),
            callMakeRequestCallbacks: new Map(),
            callHangupRequestCallbacks: new Map(),
            callAnswerRequestCallbacks: new Map(),
            clearEndpointFilterCallbacks: new Map(),
            privateMediaMessageCallbacks: new Map()
        };

        var eventDispatcher = {
            events: {},
            on: function on(event, callback) {
                var handlers = this.events[event] || [];
                handlers.push(callback);
                this.events[event] = handlers;

                return function() {
                    for (var i = 0; i < handlers.length; i++) {
                        if (callback === handlers[i]) {
                            handlers.splice(i, 1);
                            break;
                        }
                    }
                };
            },
            trigger: function trigger(event, data) {
                var handlers = this.events[event];

                if (!handlers || handlers.length < 1) return;

                [].forEach.call(handlers, function (handler) {
                    try {
                        handler(data);
                    } catch (e) {
                        util.wtcpError("An error occurred in the callback subscribed to " + event + ": " + e.message);
                    }
                });
            }
        };

        var EventSubscriber = function(event) {
            return {
                subscribe: function (callback) {
                    return eventDispatcher.on(event, callback);
                }
            }
        }

        var workerError = function workerError(e) {
            util.wtcpError(" in Worker: " + e.message);
        };

        var workerMessage = function workerMessage(e) {
            try {
                if (local[e.data.cmd].length < 2) local[e.data.cmd](e.data.value); else local[e.data.cmd](e.data.value, e.data.tranid);
            } catch (e) {
                if (typeof e.data !== "undefined") util.wtcpError("Unknown function called from worker: ", e.data.cmd); else {
                    util.wtcpError("Worker exception thrown", e);
                }
            }
        };

        var clearCallStates = function() {
            // Clear PTT pending flags since the call is no longer active
            pttUpPending = false;
            pttDownPending = false;
            pttOn = false;
        }

        Object.assign(settings, defaults, clientOptions);
        util.setLoggingLevel(settings.loggingLevel);

        var path = util.getScriptPath();

        // In future release there will be some criteria provided by locator to determine which audio handler to use
        // The correct one will be dynamically loaded at run time. For now defaulting to WTCPAudio
        var audioHandler = new audio.WTCPAudio(this, settings);

        Object.assign(local, audioHandler.messageHandlers);

        var cb;
        var instanceId = registerInstance();
        var wtcpWorker = {
            terminate: function terminate() { },
            postMessage: function postMessage() {
                throw "worker not initialized, you must first connect to a WAVE Proxy";
            }
        };

        /* --- Public properties --- */
        Object.defineProperty(this, "LibraryVersion", { get: function () {
            // this gets replaced by gulp at build-time
            // VERSION_PLACEHOLDER
        }});
        Object.defineProperty(this, "WTCPVersion", { get: function () { return locator.version; } });
        Object.defineProperty(this, "ServerId", { get: function () { return locator.proxyServerID; } });
        Object.defineProperty(this, "IsClientActive", { get: function () { return socketActive; } });
        Object.defineProperty(this, "WTCPAudioStatus", { get: function () { return audioHandler.getStatus(); } });
        Object.defineProperty(this, "AudioPlayerActive", {
            get: function () { return audioHandler.PlayerEnabled; },
            set: function (newValue) {
                settings.audioPlayerActive = newValue;
                audioHandler.PlayerEnabled = newValue;
            }
        });

        console.info('WctpJS v' + this.LibraryVersion);
        console.info('logging level: ' + settings.loggingLevel);
        // Private Function definitions

        var teardownClient = function teardownClient() {
            locator = null;
            wtcpWorker.terminate(); // Consider having worker close itself to give it a chance to shutdown gracefully
            delete proxyGlobals[instanceId];

            util.wtcpInfo("WtcpJs Client worker teardown complete");
        };

        var sendMessage = function sendMessage(cmd, tranid, value, transfer) {
            if (!socketActive && !(cmd === "init" || cmd === "connect")) throw "Can't call " + cmd + ", Socket is not active! You must call connect() before using the Client object";
            value = value || {};
            tranid = tranid || 1;

            if (!transfer) transfer = [];

            wtcpWorker.postMessage({
                "tranid": tranid,
                "cmd": cmd,
                "value": value
            }, transfer);
        };

        var init = function init() { };

        var initWorker = function initWorker() {

            sendMessage("init", 1, {
                wtcpjsPath: path + "wtcpjs.js",
                settings: settings
            });
        };

        var openSession = function openSession() {
            return new Promise(function (resolve, reject) {

                sendMessage("openSession", pushCallbacks(callbacks.openSessionCallbacks, resolve, reject), {
                    pingIntervalOption: settings.pingInterval,
                    deviceId: settings.deviceId,
                    platformString: ua ? `${settings.applicationName}-${ua.os.name}-${ua.os.version}-${ua.cpu.architecture}` : `${settings.applicationName}-?-?-?`
                });
            });
        };

        var sendCredentials = function sendCredentials(tranId, userId, password, profile) {
            //WTCP Protocol Specification says to MD5 the password, but that doesn't seem to work on proxy...
            //var md5hash = CryptoJS.MD5(password);

            if (!profile) profile = "";

            sendMessage("sendCredentials", tranId, {
                userId: userId,
                password: password,
                profile: profile,
                uuid: settings.licenseUUID
            });
        };

        var login = function login(usr, pwd, profileId) {
            util.wtcpInfo("Connect Success");

            return openSession().then(function (args) {
                return new Promise(function (resolve, reject) {
                    let tranId = pushCallbacks(callbacks.sendCredentialsCallbacks, resolve, reject);

                    if (profileId) sendCredentials(tranId, usr, pwd, profileId); else sendCredentials(tranId, usr, pwd, "");
                }, function (args) {
                    //options.error.call(this, args);
                });
            });
        };

        /* --- Worker.onmessage functions --- */

        local.setEndpointPropertiesResponse = function (data, t) {

            cb = getCallback(callbacks.setEndpointPropsCallbacks, t);
            if (cb) {
                cb.resolve(data);
            }
            util.wtcpInfo("setEndpointPropertiesResponse", data);
        };

        local.signalingSyntaxError = function (data) {
            eventDispatcher.trigger(eventList.SIGNAL_RECEIVED, data);
            util.wtcpInfo("Signaling op-code 1: Syntax Error received", data);
        };

        local.openSessionResponse = function (data, t) {

            cb = getCallback(callbacks.openSessionCallbacks, t);
            if (cb) {
                cb.resolve(data);
            }
            util.wtcpInfo("OpenSessionResponse", data);
        };

        local.openSessionError = function (data, t) {
            socketActive = false;
            cb = getCallback(callbacks.openSessionCallbacks, t);
            if (cb) {
                cb.reject(data);
            }
            util.wtcpInfo("openSessionError", data);
        };

        local.closeSessionResponse = function (data, t) {
            teardownClient();
            cb = getCallback(callbacks.closeSessionCallbacks, t);
            if (cb) cb.resolve(); 

            util.wtcpInfo("Proxy session closed");
        };

        local.closeSessionUnsolResponse = function (data) {
            eventDispatcher.trigger(eventList.SESSION_CLOSED_RECEIVED, data);
            util.wtcpError("closeSessionError", data);
        };

        local.sendCredentialsResponse = function (data, t) {
            cb = getCallback(callbacks.sendCredentialsCallbacks, t);
            if (cb) cb.resolve(data);

            // Need to add cb here
            util.wtcpInfo("sendCredentialsResponse", data);
        };

        local.sendCredentialsError = function (data, t) {
            cb = getCallback(callbacks.sendCredentialsCallbacks, t);
            if (cb) cb.reject(data);

            util.wtcpError("sendCredentialsResponse", data);
            // Need to add callbacks here
        };

        local.setActiveChannelsResponse = function (data, t) {
            cb = getCallback(callbacks.setActiveChannelsCallbacks, t);
            if (cb) {
                if (data.hasErrors && data.channelResponses.length === 0) cb.reject(data.failedChannelResponses);
                else cb.resolve(data);
            }
            util.wtcpInfo("setChannelsResponse", data);
        };

        local.unsolProxyUpdate = function (data) {
            eventDispatcher.trigger(eventList.PROXY_UPDATED, data);
            util.wtcpInfo("unsolicitedProxyUpdate", data);
        };

        local.getChannelPropertiesUnsol = function (data) {
            eventDispatcher.trigger(eventList.CHANNEL_PROPS_RECEIVED, data);
            util.wtcpInfo("getChannelPropertiesUnsol", data);
        };

        local.getChannelPropertiesResponse = function (data, t) {
            cb = getCallback(callbacks.getChannelPropsCallbacks, t);
            if (cb) {
                cb.resolve(data);
            }
            util.wtcpInfo("getChannelPropertiesResponse", data);
        };

        local.getChannelPropertiesError = function (data, t) {
            cb = getCallback(callbacks.getChannelPropsCallbacks, t);
            if (cb) {
                cb.reject(data);
            }
            util.wtcpError("getChannelPropertiesError", data);
        };

        local.setChannelPropertiesResponse = function (data, t) {
            cb = getCallback(callbacks.setChannelPropsCallbacks, t);
            if (cb) {
                cb.resolve(data);
            }
            util.wtcpInfo("setChannelPropertiesResponse", data);
        };

        local.setChannelPropertiesError = function (data, t) {
            cb = getCallback(callbacks.setChannelPropsCallbacks, t);
            if (cb) {
                cb.reject(data);
            }
            util.wtcpError("setChannelPropertiesError", data);
        };

        local.channelActivityResponse = function (data, t) {
            cb = getCallback(callbacks.channelActivityCallbacks, t);
            if (cb) {
                cb.resolve(data);
            }
            util.wtcpInfo("channelActivityResponse", data);
        };

        local.channelActivityError = function (err, t) {
            cb = getCallback(callbacks.channelActivityCallbacks, t);
            if (cb) {
                cb.reject(err);
            }
            util.wtcpError("channelActivityError", err);
        };

        local.channelActivityUnsolicited = function (data) {
            eventDispatcher.trigger(eventList.CHANNEL_ACTIVITY, data);
            util.wtcpInfo("channelActivityUnsolicited", data);
        };

        local.endpointLookupResponse = function (data, t) {
            cb = getCallback(callbacks.getEndpointLookupCallbacks, t);
            if (cb) {
                cb.resolve(data);
            }
            util.wtcpInfo("endpointLookUpResponse", data);
        };

        local.endpointLookupError = function (data, t) {
            cb = getCallback(callbacks.getEndpointLookup, t);
            if (cb) {
                cb.reject(data);
            }
        };

        local.getEndpointPropertiesResponse = function (data, t) {
            cb = getCallback(callbacks.getEndpointPropsCallbacks, t);
            if (cb) {
                cb.resolve(data);
            }
        };

        local.getEndpointPropertiesError = function (data, t) {
            cb = getCallback(callbacks.getEndpointPropsCallbacks, t);
            if (cb) {
                cb.reject(data);
            }
        };

        local.getEndpointPropertiesUnsolicited = function (data) {
            // Not sure if this opCode is ever sent from Proxy. Test it... if not, combine this with _RESP directly above
            eventDispatcher.trigger(eventList.ENDPOINT_PROPS_RECEIVED, data);
            util.wtcpInfo("getEndpointPropertiesUnsolicited", data);
        };

        local.setEndpointPropertiesError = function (data, t) {
            cb = getCallback(callbacks.setEndpointPropsCallbacks, t);
            if (cb) {
                cb.reject(data);
            }
            util.wtcpError("setEndpointPropertiesError", data);
        };

        local.pttResponse = function (data, t) {
            pttDownPending = false;
            cb = getCallback(callbacks.pttDownCallbacks, t);
            if (cb) {
                if (!pttUpPending) {
                    cb.resolve(data);
                    if (audioHandler && data.channelResponses.length > 0 && data.channelResponses[0].errorCode === 0) {
                        audioHandler.sendAudio();

                        util.wtcpInfo("PTT On", data);
                    } else {
                        pttOn = false;
                        util.wtcpInfo("PTT Off", data);
                    }
                } else {
                    // PTTUp was called before the PTTDown response came back
                    pttUpPending = false;
                    util.wtcpInfo("Cancelling PTTDown because PTTUp request came before PTTDown response was received from proxy");
                    cb.reject(wtcpJsClientErrors["PTT_NOT_READY"]);
                    sendPttUp()
                        .then((data) => {
                        // TBD: This is not working correctly. PTT while another channel is clocking waiting for response
                        // leads to bad state on the channel you are trying to PTT on
                            pttUpSuccess(data);
                        })
                        .catch((err) => {
                            pttUpFailure(err);
                        });
                }
            }
        };

        local.pttError = function (err, t) {
            cb = getCallback(callbacks.pttDownCallbacks, t);
            if (cb) {
                cb.reject(err);
            }

            pttOn = false;
            pttUpPending = false;

            util.wtcpError("PTT Down Error", err);
        };

        local.pttOff = function (data, t) { // Unsolicited PTT Off message
            pttOn = false;
            eventDispatcher.trigger(eventList.PTT_OFF, data);
            util.wtcpInfo("PTT Off", data);
        };

        local.setActivePhoneLinesResponse = function (data, t) {
            cb = getCallback(callbacks.setActivePhoneLinesCallbacks, t);
            if (cb) {
                cb.resolve(data);
            }
            util.wtcpInfo("setActivePhoneLinesResponse", data);
        };

        local.setActivePhoneLinesError = function (data, t) {
            cb = getCallback(callbacks.setActivePhoneLinesCallbacks, t);
            if (cb) {
                cb.reject(data);
            }
            util.wtcpError("ActivePhoneLineError", data);
        };

        local.phoneLineStatusUnsol = function (data, t) {
            util.wtcpInfo("phoneLineStatusUnsol", data);
            eventDispatcher.trigger(eventList.PHONE_LINE_STATUS_CHANGED, data);
        };

        local.callProgressUnsol = function(data, t) {
            util.wtcpInfo("callProgressUnsol", data);
            eventDispatcher.trigger(eventList.CALL_PROGRESS_RECEIVED, data);
        };

        local.muteChannelResponse = function (data, t) {
            cb = getCallback(callbacks.muteChannelCallbacks, t);
            if (cb) cb.resolve(data);

            util.wtcpInfo("Mute Channel Response", data);
        };

        local.muteChannelError = function (data, t) {
            cb = getCallback(callbacks.muteChannelCallbacks, t);
            if (cb) cb.reject(data);

            util.wtcpError("Mute Channel Error", data);
        };

        local.pingResponse = function (data, t) {
            util.wtcpInfo("Proxy Pong", data);
        };

        local.pongResponse = function (data) {
            eventDispatcher.trigger(eventList.PING_PONG_RESPONSE, data);
            util.wtcpInfo("Proxy Pong response to client Ping", data);
        };

        local.pingRequest = function (data, t) {
            util.wtcpInfo("Proxy Ping", data);
        };

        local.dtmfResponse = function (t) {
            cb = getCallback(callbacks.dtmfSendCallbacks, t);
            if (cb) cb.resolve();

            util.wtcpInfo("DTMF Send Response");
        };

        local.dtmfError = function (data, t) {
            cb = getCallback(callbacks.dtmfSendCallbacks, t);
            if (cb) cb.reject(data);

            util.wtcpError("DTMF Send Error", data);
        };

        local.dtmfUnsol = function (data) {
            eventDispatcher.trigger(eventList.DTMF_RECEIEVED, data);

            util.wtcpInfo("DTMF Received", data);
        };

        local.callPttOnResponse = function (data, t) {

            pttDownPending = false;
            cb = getCallback(callbacks.pttDownCallbacks, t);
            if (cb) {
                cb.resolve(data);
                if (!pttUpPending) {
                        audioHandler.sendAudio();

                        util.wtcpInfo("Private Call PTT On", data);
                } 
            }

            cb = getCallback(callbacks.callPTTOnCallbacks, t);
            if (cb) cb.resolve(data);

            if (audioHandler && data.errorCode === 0) audioHandler.sendAudio(); else pttOn = false;

            util.wtcpInfo("Call PTT On Response", data);
        };

        local.callPttOnError = function (data, t) {
            cb = getCallback(callbacks.callPTTOnCallbacks, t);
            if (cb) cb.reject(data);

            pttOn = false;

            util.wtcpError("Call PTT On Error", data);
        };

        local.callPttOnUnsol = function (data) {
            eventDispatcher.trigger(eventList.CALL_PTT_ON_RECEIVED, data);
            util.wtcpInfo("Call PTT On Received", data);
        };

        local.callPttOffResponse = function (data, t) {
            cb = getCallback(callbacks.callPTTOffCallbacks, t);
            if (cb) cb.resolve(data);

            pttOn = false;

            if (pttUpPending) {
                pttUpPending = false;
                util.wtcpInfo("Cancelling callPTTOn because callPTTOff request came before callPTTOn response was received from proxy");
                sendCallPttUp(d.callId)
                    .then((data) => {
                        pttUpSuccess(data);
                    })
                    .catch((err) => {
                        pttUpFailure(err);
                    });
            }

            util.wtcpInfo("Call PTT Off Response", data);
        };

        local.callPttOffError = function (data, t) {
            cb = getCallback(callbacks.callPTTOffCallbacks, t);
            if (cb) cb.reject(data);

            util.wtcpError("Call PTT Off Error", data);
        };

        local.callPttOffUnsol = function (data) {
            eventDispatcher.trigger(eventList.CALL_PTT_OFF_RECEIVED, data);
            util.wtcpInfo("Call PTT Off Received", data);
        };

        local.addressBookGetResponse = function (data, t) {
            cb = getCallback(callbacks.addressBookCallbacks, t);
            if (cb) {
                if (data.errorCode > 0) cb.reject(data); else cb.resolve(data);
            }

            util.wtcpInfo("Address Book Info Response", data);
        };

        local.textMessageResponse = function (data, t) {
            cb = getCallback(callbacks.textMessageCallbacks, t);
            if (cb) {
                data.textMsgConfirmedDate = new Date(Date.now());
                cb.resolve(data);
            }

            util.wtcpInfo("Text Message Sent", data);
        };

        local.textMessageError = function (data, t) {
            cb = getCallback(callbacks.textMessageCallbacks, t);
            if (cb) cb.reject(data);

            util.wtcpError("Error sending Text Message", data);
        };

        local.textMessageUnsol = function (data) {
            eventDispatcher.trigger(eventList.TXT_MSG_RECEIVED, data);
            util.wtcpInfo("Text Message Received", data);
        };

        local.privateMediaMessageResponse = function (data, t) {
            cb = getCallback(callbacks.privateMediaMessageCallbacks, t);
            if(cb) {
                data.textMsgConfirmedDate = new Date(Date.now());
                cb.resolve(data);
            }

            util.wtcpInfo("Private Media Message Sent", data);
        };

        local.privateMediaMessageError = function (data, t) {
            cb = getCallback(callbacks.privateMediaMessageCallbacks, t) ;
            if(cb) cb.reject(data);

            util.wtcpError("Error sending Private Media Message");
        }

        local.privateMediaMessageUnsol = function(data, t) {
            eventDispatcher.trigger(eventList.PRIV_MEDIA_MSG_RECEIVED, data);
            util.wtcpInfo("Private Media Message Received", data);
        };

        local.callMakeResponse = function(data, t) {
            cb = getCallback(callbacks.callMakeRequestCallbacks, t);
            if (cb) {
                if (data.errorCode > 0) cb.reject(data); else cb.resolve(data);
            }
            util.wtcpInfo("Call Make acknowledged by Proxy", data);
        };

        local.callHangupResponse = function(data, t) {
            clearCallStates();
            cb = getCallback(callbacks.callHangupRequestCallbacks, t);
            if (cb) {
                if (data.errorCode > 0) cb.reject(data); else cb.resolve(data);
            }
            util.wtcpInfo("Call Hang-up acknowledged by Proxy", data);
        };

        local.callAnswerResponse = function(data, t) {
            cb = getCallback(callbacks.callAnswerRequestCallbacks, t);
            if (cb) {
                if (data.errorCode > 0) cb.reject(data); else cb.resolve(data);
            }
            util.wtcpInfo("Call Answer acknowledged by Proxy", data);
        };

        local.callHangupUnsol = function(data, t) {
            clearCallStates();
            eventDispatcher.trigger(eventList.CALL_HANGUP_RECEIVED, data);
            util.wtcpInfo("Call Hangup Received", data);
        };

        local.callOfferUnsol = function(data, t) {
            eventDispatcher.trigger(eventList.CALL_OFFER_RECEIVED, data);
            util.wtcpInfo("Call Offer Received", data);
        };

        // Version 2
        local.setEndpointPropertiesFilterResponse = function (data, t) {
            cb = getCallback(callbacks.endpointPropFilteringCallbacks, t);
            if (cb) cb.resolve(data);

            util.wtcpInfo("Set Endpoint Prop Filter Response", data);
        };

        local.setEndpointPropertiesFilterError = function (data, t) {
            cb = getCallback(callbacks.endpointPropFilteringCallbacks, t);
            if (cb) cb.reject(data);

            util.wtcpError("Set Endpoint Prop Filter Error", data);
        };

        local.setEndpointFilterResponse = function (data, t) {
            cb = getCallback(callbacks.endpointFilteringCallbacks, t);
            if (cb) cb.resolve(data);

            util.wtcpInfo("Set Endpoint Filter Response", data);
        };

        local.setEndpointFilterError = function (data, t) {
            cb = getCallback(callbacks.endpointFilteringCallbacks, t);
            if (cb) cb.reject(data);

            util.wtcpError("Set Endpoint Filter Error", data);
        };

        local.clearEndpointFilterResponse = function(data, t) {
            cb = getCallback(callbacks.clearEndpointFilterCallbacks, t);
            if (cb) cb.resolve(data);

            util.wtcpInfo("Clear Endpoint Filer Response", data);
        };

        local.clearEndpointFilterError = function(data, t) {
            cb = getCallback(callbacks.clearEndpointFilterCallbacks, t);

            if (cb) cb.reject(data);

            util.wtcpError("Clear Endpoint Filter Error", data);
        };

        local.playAudio = function (data) {
            //audioHandler.playAudio(d.audioMessages, d.audioLength, d.data);
            audioHandler.playAudio(data.audioArrayBuffer, data.audioLength);
        };

        local.connectionInfoUpdated = function(data, t) {
            eventDispatcher.trigger(eventList.CONNECTION_INFO_UPDATED, data);
            util.wtcpInfo("Connection Info Updated", data);
        };

        local.wsConnected = function (d, t) {
            socketActive = true;

            cb = getCallback(callbacks.socketConnectedCallbacks, t);
            if (cb) cb.resolve();

            util.wtcpInfo("Web Socket connection established");
        };

        local.wsClosed = function (closeEvent) {
            socketActive = false;
            eventDispatcher.trigger(eventList.SOCKET_CLOSED, closeEvent);
            util.wtcpInfo("Web Socket connection closed", closeEvent);
        };

        local.wsError = function (data, t) {
            cb = getCallback(callbacks.socketConnectedCallbacks, t);
            if (cb) cb.reject(data);

            util.wtcpError("Web Socket connection failed", data);
        };

        // Expose two functions for unit testing

        this.pushCallbacks = pushCallbacks;
        this.getCallback = getCallback;

        /* --- Public events --- */
        this.onConnectionClosed = new EventSubscriber(eventList.SOCKET_CLOSED);

        this.onSessionClosed = new EventSubscriber(eventList.SESSION_CLOSED_RECEIVED);

        this.onProxyUpdated = new EventSubscriber(eventList.PROXY_UPDATED);

        this.onChannelPropertiesReceived = new EventSubscriber(eventList.CHANNEL_PROPS_RECEIVED);

        this.onChannelActivity = new EventSubscriber(eventList.CHANNEL_ACTIVITY);

        this.onEndpointPropertiesReceived = new EventSubscriber(eventList.ENDPOINT_PROPS_RECEIVED);

        this.onPhoneLineStatusChanged = new EventSubscriber(eventList.PHONE_LINE_STATUS_CHANGED);

        this.onCallProgressReceived = new EventSubscriber(eventList.CALL_PROGRESS_RECEIVED);

        this.onCallHangupReceived = new EventSubscriber(eventList.CALL_HANGUP_RECEIVED);

        this.onCallOfferReceived = new EventSubscriber(eventList.CALL_OFFER_RECEIVED);

        this.onPTTOff = new EventSubscriber(eventList.PTT_OFF);

        this.onDTMFReceived = new EventSubscriber(eventList.DTMF_RECEIEVED);

        this.onCallPTTOnReceived = new EventSubscriber(eventList.CALL_PTT_ON_RECEIVED);

        this.onCallPTTOffReceived = new EventSubscriber(eventList.CALL_PTT_OFF_RECEIVED);

        this.onTextMessageReceived = new EventSubscriber(eventList.TXT_MSG_RECEIVED);

        this.onPrivateMediaMessageReceived = new EventSubscriber(eventList.PRIV_MEDIA_MSG_RECEIVED);

        this.onPingResponse = new EventSubscriber(eventList.PING_PONG_RESPONSE);

        this.onConnectionInfoUpdated = new EventSubscriber(eventList.CONNECTION_INFO_UPDATED);

        /* --- Public client functions --- */
        this.connect = function (serverUrl, username, password, profileId) {

            if (wtcpWorker) {
                // Re-connecting - terminate existing worker
                wtcpWorker.onerror = null;
                wtcpWorker.onmessage = null;
                wtcpWorker.terminate();
                locator = null;
            }

            wtcpWorker = clientWorker || new Worker(path + 'wtcp-worker-api.js');

            wtcpWorker.onerror = workerError;
            wtcpWorker.onmessage = workerMessage;

            initWorker();

            return new Promise(function (resolve, reject) {
                var tranId = pushCallbacks(callbacks.socketConnectedCallbacks, resolve, reject);
                locator = new locService.Locator();
                if (serverUrl.match(serverUrlPattern)) {
                    locator.webSocketServer = serverUrl;

                    sendMessage("connect", tranId, {
                        locator: locator
                    });
                } else {
                    locator.getProxy(serverUrl).then(function () {
                        if (locator.proxyServerID == null) throw "Locator not initialized, call getProxy()";

                        let _address;
                        if (locator.wsPort) {
                            _address = `${locator.address[0]}:${locator.wsPort}`;
                        } else {
                            _address = locator.address[0];
                        }

                        if (!!serverUrl.match(httpsPattern)) {
                            locator.webSocketServer = `wss://${_address}`;
                        } else {
                            locator.webSocketServer = `ws://${_address}`;
                        }

                        sendMessage("connect", tranId, {
                            locator: locator
                        });
                    })["catch"](function (err) {
                        reject(err);
                    });
                }
            }).then(function () {
                return login(username, password, profileId);
            }, function (err) {
                throw "error connecting to Proxy";
            });
        };

        this.setProfile = function (username, password, profileId) {
            return new Promise(function (resolve, reject) {
                let tranId = pushCallbacks(callbacks.sendCredentialsCallbacks, resolve, reject);

                sendCredentials(tranId, username || "", password || "", profileId || "");
            });
        };

        // Proxy Request Messages
        this.closeSession = function () {
            return new Promise(function(resolve, reject) {
                sendMessage("closeSession", pushCallbacks(callbacks.closeSessionCallbacks, resolve, reject));
            });
        };

        this.setActiveChannels = function (channelIds) {
            if (!channelIds || !(typeof channelIds === "object")) channelIds = [];

            return new Promise(function (resolve, reject) {

                sendMessage("setActiveChannels", pushCallbacks(callbacks.setActiveChannelsCallbacks, resolve, reject), {
                    channelIds: channelIds
                });
            });
        };

        this.getChannelProperties = function (channelId) {
            ///<summary>Requests Channel Properties from Proxy</summary>
            ///<param name="channelId" type="int">Channel ID to request properties for</param>
            if (!channelId) throw "getChannelPropertiesRequest(channelId) requires a valid channel Id";

            return new Promise(function (resolve, reject) {

                sendMessage("getChannelPropertiesRequest", pushCallbacks(callbacks.getChannelPropsCallbacks, resolve, reject), {
                    channelId: channelId
                });
            });
        };

        this.setChannelProperties = function (channelId, props) {
            ///<summary>Request Proxy save or update Channel Properties</summary>
            ///<param name="channelId" type="int">Channel ID to set properties for</param>
            ///<param name="props" type="object">json object containing key-value pairs</param>
            if (!channelId) throw "setChannelPropertiesRequest(channelId, properties) expects a valid channel Id";

            return new Promise(function (resolve, reject) {

                sendMessage("setChannelPropertiesRequest", pushCallbacks(callbacks.setChannelPropsCallbacks, resolve, reject), {
                    channelId: channelId,
                    props: props
                });
            });
        };

        this.getChannelActivity = function (channelId) {
            if (!channelId) throw "channelActivityRequest(channelId) requires a valid channel Id";

            return new Promise(function (resolve, reject) {

                sendMessage("channelActivityRequest", pushCallbacks(callbacks.channelActivityCallbacks, resolve, reject), {
                    channelId: channelId
                });
            });
        };

        this.endpointLookup = function (channelId, includeFlags, excludeFlags, pageSize, pageNumber, nameBeginsWith) {
            if (!channelId) throw "channelActivityRequest(channelId) requires a valid channel Id";

            includeFlags = includeFlags || new wtcp.EndpointFlags();
            excludeFlags = excludeFlags || new wtcp.EndpointFlags();
            pageSize = pageSize || 1;
            pageNumber = pageNumber || 1;
            nameBeginsWith = nameBeginsWith || "";

            return new Promise(function (resolve, reject) {

                sendMessage("endpointLookupRequest", pushCallbacks(callbacks.getEndpointLookupCallbacks, resolve, reject), {
                    channelId: channelId,
                    includeFlags: includeFlags,
                    excludeFlags: excludeFlags,
                    pageSize: pageSize,
                    pageNumber: pageNumber,
                    nameBeginsWith: nameBeginsWith
                });
            });
        };

        this.getEndpointProperties = function (endpointId, propList, channelId) {
            if (!endpointId) throw "getEndpointProperties(endpointId, properties) requires a valid endpoint Id";

            var msgBody = {
                endpointId: endpointId,
                propList: propList
            };

            if (channelId != null) {
                msgBody.channelId = channelId;
            }

            return new Promise(function (resolve, reject) {

                sendMessage("getEndpointPropertiesRequest", pushCallbacks(callbacks.getEndpointPropsCallbacks, resolve, reject), msgBody );
            });
        };

        this.setEndpointProperties = function (endpointId, props) {
            if (!endpointId) throw "setEndpointProperties(endpointId, properties) requires a valid endpoint Id";

            return new Promise(function (resolve, reject) {

                sendMessage("setEndpointPropertiesRequest", pushCallbacks(callbacks.setEndpointPropsCallbacks, resolve, reject), {
                    endpointId: endpointId,
                    props: props
                });
            });
        };

        this.PTTDown = function (channelIds) {
            if (!channelIds || Object.prototype.toString.call(channelIds) !== "[object Array]" || channelIds.length === 0) throw "PTTDown requires an array of channel ids";
            pttDownPending = true;

            return new Promise(function (resolve, reject) {

                if (!pttOn && !pttUpPending) {
                    pttOn = true;
                    sendMessage("PTTDown", pushCallbacks(callbacks.pttDownCallbacks, resolve, reject), {
                        channelIds: channelIds
                    });
                } else {
                    util.wtcpError(`ALERT: PTTDown pttOn=${pttOn} and pttUpPending=${pttUpPending}`);
                    reject(wtcpJsClientErrors["PTT_NOT_READY"]);
                }
            });
        };

        function sendPttUp() {
            let sendMessagePromise = new Promise(function (resolve, reject) {
                sendMessage("PTTUp", pushCallbacks(callbacks.pttDownCallbacks, resolve, reject));
            });

            // wait promise for a second before timeout 
            return util.promiseTimeout(1000, sendMessagePromise)
                    .then((result) => { util.wtcpInfo("Sending a message : ", result); 
                                        return result; })
                    .catch(err => { util.wtcpInfo("ALERT : sending a message :",err);
                                    return err; });
        }

        function awaitPttUp() {
            let awaitPromise =  new Promise(function(resolve, reject) {
                pttUpPending = true;
                pttUpSuccess = resolve;
                pttUpFailure = reject;
            });

            // wait promise for a second before timeout
            return util.promiseTimeout(1000, awaitPromise)
                   .then((result) => { util.wtcpInfo("awaitPttUp done, result =", result);
                                       pttUpPending = false; 
                                       pttOn = false;
                                       return result;
                                     })
                   .catch(err => { util.wtcpInfo("awaitPttUp. exception =", errr);
                                   return err;
                                  });
        }

        this.PTTUp = function () {
            if (pttDownPending) {
                return awaitPttUp();
            } else {
                if (audioHandler) {
                    return util.promiseTimeout(1000, audioHandler.endAudio())
                            .then(() => {return sendPttUp();})
                            .catch((err) => {
                                // will send sendPttUp even if failed to close endAudio
                                util.wtcInfo('ALERT: PttUp failed while waiting endAudio call', err);
                                return sendPttUp();
                            });
                } else {
                    util.wtcpDebug("no audio handler");
                    return sendPttUp();
                }
            }
        };

        function sendCallPttUp(callId) {
            return new Promise(function (resolve, reject) {
                sendMessage("callPTTOffRequest", pushCallbacks(callbacks.callPTTOffCallbacks, resolve, reject), {
                    callId: callId
                });
            });
        }

        this.callPTTOn = function(callId) {
            if (!callId) throw "callPTTOn(callId) requires a valid call Id";

            pttDownPending = true;

            return new Promise(function(resolve, reject) {

                if (!pttOn) {
                    pttOn = true;

                    sendMessage("callPTTOnRequest", pushCallbacks(callbacks.callPTTOnCallbacks, resolve, reject), {
                        callId: callId
                    });
                } else {
                    reject(wtcpJsClientErrors["PTT_NOT_READY"]);
                }
            });
        };

        this.callPTTOff = function (callId) {
            if (!callId) throw "callPTTOff(callId) requires a valid call Id";

            if (pttDownPending) {

                return awaitPttUp();
            } else {
                if (audioHandler) {
                    return audioHandler.endAudio().then(() => {
                        return sendCallPttUp(callId);
                    }).catch((err) => {
                        util.wtcpError('callPTTOff failed', err);
                    });
                } else {
                    return sendCallPttUp(callId);
                }
            }
        };

        this.setActivePhoneLines = function (phoneLines) {
            let fail = !phoneLines;

            if (!fail) {
                for (let line of phoneLines) {
                    if (!line) {
                        fail = true;
                        break;
                    }
                }
            }

            if (fail ) throw "setActivePhoneLines requires a list of phone lines";

            return new Promise(function (resolve, reject) {

                sendMessage("setActivePhoneLines", pushCallbacks(callbacks.setActivePhoneLinesCallbacks, resolve, reject), {
                    phoneLines: phoneLines
                });
            });
        };

        this.makeCall = function (type, source, destination) {
            ///<summary>Make a point-to-point call request</summary>
            ///<param name="type" type="int">Endpoint == 1, E164 number == 2</param>
            ///<param name="source" type="string">Phone line to use to make the call (as returned by "Start Call Provider") response</param>
            ///<param name="destination" type="string">if type === 1, then this is the endpoint to reach, otherwise it is the phone number to call</param>
            ///<returns type="Promise">Returns a Promise</returns>
            if (!type) throw "makeCall(type, source, destination) requires type, source, and destination";

            return new Promise(function (resolve, reject) {

                sendMessage("callMakeRequest", pushCallbacks(callbacks.callMakeRequestCallbacks, resolve, reject), {
                    type: type,
                    source: source,
                    destination: destination
                });
            });
        };

        this.answerCall = function(callId) {
            if (!callId) throw "answerCall requires a valid call Id";

            return new Promise(function(resolve, reject) {
                sendMessage("callAnswerRequest", pushCallbacks(callbacks.callAnswerRequestCallbacks, resolve, reject), {
                    callId: callId
                });
            });
        };

        this.hangupCall = function (callId) {
            if (!callId) throw "hangupCall requires a valid call Id";

            return new Promise(function (resolve, reject) {

                sendMessage("callHangUpRequest", pushCallbacks(callbacks.callHangupRequestCallbacks, resolve, reject), {
                    callId: callId
                });
            });
        };

        this.muteAllChannels = function () {
            return new Promise(function (resolve, reject) {

                sendMessage("muteAllChannels", pushCallbacks(callbacks.muteChannelCallbacks, resolve, reject));
            });
        };

        this.unmuteAllChannels = function () {
            return new Promise(function (resolve, reject) {

                sendMessage("unmuteAllChannels", pushCallbacks(callbacks.muteChannelCallbacks, resolve, reject));
            });
        };

        this.muteChannels = function (channels) {
            if (!channels) throw "muteChannels(chanels) requires a valid list of channels";

            return new Promise(function (resolve, reject) {

                sendMessage("muteChannels", pushCallbacks(callbacks.muteChannelCallbacks, resolve, reject), { channels: channels });
            });
        };

        this.dtmfSendRequest = function (callId, dtmf) {
            if (!callId) throw "dtmfSendRequest(callId) was called without a valid callId";

            return new Promise(function (resolve, reject) {

                sendMessage("dtmfSendRequest", pushCallbacks(callbacks.dtmfSendCallbacks, resolve, reject), {
                    callId: callId,
                    dtmf: dtmf
                });
            });
        };

        this.getAddressBook = function (pageSize, pageNum, filter) {
            if (locator.version === 1 || !filter || filter.length === 0) filter = "*";

            return new Promise(function (resolve, reject) {

                sendMessage("getAddressBook", pushCallbacks(callbacks.addressBookCallbacks, resolve, reject), {
                    pageSize: pageSize || 200,
                    pageNum: pageNum || 1,
                    filter: filter
                });
            });
        };

        function getDefaultOptions() {
            var options = {};

            if (!options.hasOwnProperty("important")) options.important = false;

            return options
        }

        this.sendTextMessage = function (channelId, message, options) {
            if (!channelId || typeof channelId !== "number") throw "sendTextMessage(channelId, message) requires a valid channel Id";

            options = options || getDefaultOptions();

            if (options.important) message = "[[ALERT1]]" + message;

            return new Promise(function (resolve, reject) {

                // Only channel text messages are currently implemented
                sendMessage("sendTextMessage", pushCallbacks(callbacks.textMessageCallbacks, resolve, reject), {
                    channelId: channelId,
                    message: message
                });
            });
        };

        this.sendP2PMessage = function(privateTextMessageRequest, options) {
            if (!privateTextMessageRequest || !privateTextMessageRequest instanceof wtcp.PrivateTextMessageRequest) throw "sendP2PMessage(privateTextMessageRequest) argument must be type PrivateTextMessageRequest";

            options = options || getDefaultOptions();

            // eventually this should be replaced with metadata and handled in the client, not WtcpJs
            if (options.important) privateTextMessageRequest.data = "[[ALERT1]]" + privateTextMessageRequest.data;

            return new Promise(function (resolve, reject) {

                // assumed will always be a text/plain message. We will have to change the signature when we support multimedia messages
                sendMessage("sendP2PMessage", pushCallbacks(callbacks.privateMediaMessageCallbacks, resolve, reject), privateTextMessageRequest);
            });
        }

        // Version 2
        var setEndpointFilter = function setEndpointFilter(type, filterId, channelId, endpointFilter, propFilter, endpointId, threshold, anchor) {
            /*if (locator.version < 2)
                throw "Endpoint filtering is only supported in WTCP version 2 or greater";*/

            return new Promise(function (resolve, reject) {

                sendMessage("setEndpointFilter", pushCallbacks(callbacks.endpointFilteringCallbacks, resolve, reject), {
                    filterId: filterId,
                    type: type,
                    channelId: channelId,
                    endpointFilter: endpointFilter,
                    propertyFilter: propFilter,
                    endpointId: endpointId,
                    notificationThreshold: threshold,
                    anchorInfo: anchor
                });
            });
        };

        this.setEndpointChannelFilter = function (filterId, channelId, endpointFilter, propFilter, threshold, anchorInfo) {
            if (!channelId) throw "channelId argument is required";

            return setEndpointFilter(2, filterId, channelId, endpointFilter, propFilter, '', threshold, anchorInfo);
        };

        this.setEndpointSPCFilter = function (filterId, endpointId, endpointFilter, propFilter, threshold, anchorInfo) {
            return setEndpointFilter(1, filterId, 0, endpointFilter, propFilter, endpointId, threshold, anchorInfo);
        };

        this.setEndpointAddressBookFilter = function (filterId, endpointFilter, propFilter, threshold, anchorInfo) {
            return setEndpointFilter(3, filterId, 0, endpointFilter, propFilter, '', threshold, anchorInfo);
        };

        this.clearEndpointFilter = function (filterId) {
            if (!filterId || isNaN(filterId)) throw new Error("Invalid argument type for filterId, must be an unsigned integer value");

            return new Promise(function (resolve, reject) {

                // Only channel text messages are currently implemented
                sendMessage("clearEndpointFilter", pushCallbacks(callbacks.clearEndpointFilterCallbacks, resolve, reject), {
                    filterId: filterId
                });
            });
        };

        var setEndpointPropertiesFilter = function(type, filter) {
            if (type < 1 || type > 6) throw "setEndpointPropertiesFilter(type, filter) type argument is required";

            return new Promise(function (resolve, reject) {

                sendMessage("setEndpointPropertiesFilter", pushCallbacks(callbacks.endpointPropFilteringCallbacks, resolve, reject), { type: type, filter: filter });
            });
        };

        this.setEndpointPropertiesPrivateCallFilter = function (filter) {
            return setEndpointPropertiesFilter(1, filter);
        };

        this.setEndpointPropertiesTextMessageFilter = function (filter) {
            return setEndpointPropertiesFilter(2, filter);
        };

        this.setEndpointPropertiesChannelActivityFilter = function (filter) {
            return setEndpointPropertiesFilter(3, filter);
        };

        this.setEndpointPropertiesPrivateMessageFilter = function (filter) {
            return setEndpointPropertiesFilter(4, filter);
        };

        this.visualizeAudio = function (canvas) {
            audioHandler.visualize(canvas);
        };

        this.setVolume = function (volume) {
            audioHandler.setVolume(volume);
        };

        this.destroy = function () {
            if (socketActive)
                return this.closeSession();
            else return new Promise(function(resolve, reject) {
                try {
                    teardownClient();
                } catch (e) {
                    reject(e);
                } finally {
                    eventDispatcher.events = {};
                    resolve();
                }
            });
        };

        this.SendMessage = sendMessage;

        init();

        return this;
    };

    module.exports = wtcp;
})(global.WtcpJs);